import React from 'react';
import { createValidationHelper, required, validateEmail } from './lib/validation-helpers.js';
import PrintableList from './printable-list';
import HonorCardSelect from './ehonor-card-select';
import HonorCardEmail from './ehonor-card-email';
import EmailReview from './email-review';
//import { triggerEcommAnalyticsEvent } from './lib/analytics-helpers';

export default class App extends React.Component {
	constructor() {
		super();
		this.appContainerClass = 'wvus-ehonor-card-app';
		this.isLoggedIn = window.wvus_checkout && window.wvus_checkout.is_user_logged_in == "1";
		this.isSsoOutage = window.wvus_checkout && wvus_checkout.ssoOutage == "1";
		this.stepShouldTransition = false;

		const productFromQs = window.wvus_ehonor_card_product_from_qs;
		const honorCardPDFs = window.wvus_ehonor_card_pdfs;
		let allProductCategories = window.wvus_ehonor_card_product_categories;

		allProductCategories.unshift({'valueKey': '', 'valueText': 'Select a gift category'});

		Object.keys(allProductCategories).forEach(function (key) {
			//console.log(allProductCategories[key]['valueText']);
			allProductCategories[key]['valueText'] = allProductCategories[key]['valueText'].replace('&amp;', '&').replace('&#038;', '&');
		});

		this.state = {
			productCategories: allProductCategories,
			showProductSelect: productFromQs ? false : true,
			selectedProduct: productFromQs ? productFromQs : null,
			honorCardPDFs: honorCardPDFs,
			formSent: false,
			formMessaging: '',
			showEmailForm: productFromQs ? true : false,
			showPreview: false,
			previewData: null,
		};

		this.funnelAnalytics = {
		};

		this.scrollToTop = this.scrollToTop.bind(this);

		this.handleNextStep = this.handleNextStep.bind(this);
		this.handlePreview = this.handlePreview.bind(this);
		this.resetFormAfterSend = this.resetFormAfterSend.bind(this);
	}

	// scrollToTop() {
	// 	$('html, body').animate({
	// 		scrollTop: $(`.${this.appContainerClass}`).offset().top
	// 	}, 500);
	// 	this.stepShouldTransition = false;
	// }

	handleNextStep(e, formData) {
		e.preventDefault();
		e.stopPropagation();

		//Pass in selected product
		this.setState((prevState) => {
			prevState.showProductSelect = false;
			prevState.showEmailForm = true;
			prevState.selectedProduct = formData[0];
			return prevState;
		});
	}

	handlePreview(fieldData) {
		this.setState((prevState) => {
			prevState.previewData = fieldData;
			prevState.showPreview = true;
			return prevState;
		});
	}

	handleBackToCart() {
		window.location.href = '/cart';
	}

	scrollToTop() {
		$('html, body').animate({
			scrollTop: $(`.site-content`).offset().top
		}, 500);
		this.stepShouldTransition = false;
	}

	resetFormAfterSend(sentMessage) {
		this.setState((prevState) => {
			prevState.showProductSelect = false;
			prevState.showEmailForm = false;
			prevState.selectedProduct = null;
			prevState.formSent = true;
			prevState.formMessaging = sentMessage;
			prevState.showPreview = false;

			return prevState;
		});
	}

	render() {

		const form = this.state.showProductSelect ? <HonorCardSelect handleNextStep={this.handleNextStep} productCategories={this.state.productCategories}></HonorCardSelect> : null;

		const emailForm = this.state.showEmailForm ? <HonorCardEmail selectedProduct={this.state.selectedProduct} scrollToTop={this.scrollToTop} handlePreview={this.handlePreview} product={this.state.selectedProduct} resetFormAfterSend={this.resetFormAfterSend}></HonorCardEmail> : null;

		const emailReview = this.state.showPreview ? <EmailReview selectedProduct={this.state.selectedProduct} emailData={this.state.previewData}></EmailReview> : null;

		return (
			<div
				className={this.appContainerClass}
				>
				<PrintableList honor_card_pdfs={this.state.honorCardPDFs} />
				{this.state.formMessaging}
				{ form }
				{ emailForm }
				{ emailReview }
			</div>	
		);
	}

}